/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import * as PropTypes from 'prop-types';
import { allVulnerabilitySeverityRatings } from '../../util/vulnerabilitySeverityRatings';
export var propTypes = {
    title: PropTypes.string,
    severityRating: PropTypes.oneOf(allVulnerabilitySeverityRatings),
    score: PropTypes.number,
    className: PropTypes.string,
    presentational: PropTypes.bool
};
//# sourceMappingURL=types.js.map